var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "#F7DF1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.414 26.7415L10.8628 25.2595C11.3353 26.0971 11.765 26.8059 12.7959 26.8059C13.784 26.8059 14.4071 26.4194 14.4071 24.9159V14.6911H17.4143V24.9584C17.4143 28.073 15.5885 29.4907 12.9248 29.4907C10.5191 29.4907 9.12275 28.2449 8.41388 26.7412L8.414 26.7415ZM19.0476 26.4192L21.4961 25.0016C22.1408 26.0542 22.9785 26.8275 24.4605 26.8275C25.7066 26.8275 26.5011 26.2045 26.5011 25.3452C26.5011 24.3142 25.6849 23.949 24.3101 23.3477L23.5585 23.0252C21.3889 22.1019 19.9498 20.9419 19.9498 18.4931C19.9498 16.2376 21.6681 14.5191 24.3533 14.5191C26.265 14.5191 27.6398 15.1851 28.6278 16.925L26.2863 18.4287C25.7706 17.5051 25.2124 17.14 24.3531 17.14C23.4724 17.14 22.9139 17.6985 22.9139 18.4287C22.9139 19.3309 23.4724 19.6962 24.7611 20.2547L25.5129 20.5769C28.0691 21.6725 29.5083 22.7894 29.5083 25.3024C29.5083 28.0091 27.3818 29.4911 24.5249 29.4911C21.7325 29.4911 19.9281 28.1594 19.0475 26.4194",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomJavascript);
export default __webpack_public_path__ + "static/media/custom_javascript.ad9bd335a79f362a3fb26e74d82bd5f5.svg";
export { ForwardRef as ReactComponent };